import classNames from 'classnames';
import { DetailedHTMLProps, forwardRef, InputHTMLAttributes } from 'react';

let id = 0;

export const Toggle = forwardRef<HTMLInputElement, DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>>(
  ({ className, ...props }, ref) => {
    const toggleId = id + 1;
    id++;

    return (
      <label
        htmlFor={`toggle-${toggleId}`}
        className={classNames('block h-6 relative transition-all', props.disabled ? 'opacity-60' : 'cursor-pointer')}
      >
        <input type="checkbox" id={`toggle-${toggleId}`} className={classNames('sr-only peer', className)} {...props} ref={ref} />
        <div
          className={classNames(
            'w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring peer-focus:ring-offset-1 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[\'\'] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-500',
            props.checked && 'peer-focus:ring-emerald-500/30',
            !props.checked && 'peer-focus:ring-slate-300/30',
          )}
        />
      </label>
    );
  }
);

Toggle.displayName = 'Toggle';
